// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"TopLiveEventsMobile_skeletonContainer--C5z","sliderContainer":"TopLiveEventsMobile_sliderContainer--gbG"};